import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import history from 'routing/history';
import { A, H5 } from 'components/Typography';
import StepOne from 'products/nomad_insurance/assets/img/claims/step-one.svg';
import StepThree from 'products/nomad_insurance/assets/img/claims/step-three.svg';
import StepFour from 'products/nomad_insurance/assets/img/claims/step-four.svg';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSquareUpRight } from '@fortawesome/pro-solid-svg-icons';
import ViewAnimator from '../ViewAnimator';
import { setClaimSubmitted, resetBankAccount, resetState } from '../../state';
import {
  StepImages,
  StepImage,
  Divider,
  DividerGray,
  NextButton,
  NPSContainer
} from './styled';
import { Instructions } from '../../styled';

const Confirmation = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const claimType = location.pathname.includes('non-medical') ? 'non-medical' : 'medical';

  useEffect(() => {
    dispatch(setClaimSubmitted(false));
    dispatch(resetBankAccount());
    dispatch(resetState());
  }, [dispatch, claimType]);

  return (
    <ViewAnimator>
      <StepImages>
        <StepImage>
          <img src={StepOne} alt="step one" />
        </StepImage>
        <Divider />
        <StepImage>
          <img src={StepThree} alt="step two" />
        </StepImage>
        <DividerGray />
        <StepImage>
          <img src={StepFour} alt="step three" />
        </StepImage>
      </StepImages>
      <H5>You’re all set!</H5>
      <Instructions>
        We’ll let you know if you need to provide extra information and/or supporting
        documents. Claims typically get paid within 10-15 days.
      </Instructions>
      <NextButton
        variant="dark"
        onClick={() => history.push('/nomad-insurance/profile/claims')}
      >
        Check claims status
      </NextButton>

      <NPSContainer>
        <A href="https://safetywinginsurance.typeform.com/nomad-claims1">
          How was your claims experience?
        </A>{' '}
        Share your thoughts to enter our monthly $250 draw. It takes less than a minute,
        plus we read and respond to every piece of feedback{' '}
        <FontAwesomeIcon icon={faSquareUpRight} color="#64809b" />
      </NPSContainer>
    </ViewAnimator>
  );
};

export default Confirmation;
